var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtend(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4V3c0-.53-.469-1-1-1-.563 0-1 .469-1 1v1H4.5A1.5 1.5 0 003 5.5V7h14V5.5c0-.812-.688-1.5-1.5-1.5H14V3c0-.53-.469-1-1-1-.563 0-1 .469-1 1v1H8zm9 4H3v8.5A1.481 1.481 0 004.5 18h11a1.5 1.5 0 001.5-1.5V8zm-3.167 5.414a.592.592 0 000-.826l.001-.002-2.857-2.915a.564.564 0 00-.809 0 .592.592 0 000 .825l1.88 1.92H6.572A.577.577 0 006 13c0 .322.255.583.571.583h5.48l-1.885 1.92a.593.593 0 000 .826.564.564 0 00.81 0l2.857-2.915z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtend);
export default ForwardRef;